/**
 * This converts bet type string in SnakeCase into kebab-case
 * @param {String} betType
 * @return String
 */
export function convertBetType(betType) {
  const betTypeSuffix = {
    FixedWin: 'fixed-win',
    FixedPlace: 'fixed-place',
    DivWin: 'tote-win',
    DivPlace: 'tote-place',
    ExchangeBack: 'exchange-win',
    ExchangePlaceBack: 'exchange-place',
    ExchangeLay: 'exchange-win-lay',
    ExchangePlaceLay: 'exchange-place-lay',
  };
  return betTypeSuffix[betType];
}

/**
 * This function returns bet type groups.
 * @param {String} betType
 * @return String
 */
export function convertBetTypeGroups(betType) {
  let betTypes;
  switch (betType) {
    case 'FixedWin':
      betTypes = 'fixed-win,tote-win,exchange-win,exchange-win-lay';
      break;
    case 'FixedPlace':
      betTypes = 'fixed-place,tote-place,exchange-place,exchange-place-lay';
      break;
    default:
      // generic sports
      betTypes = 'fixed-win,exchange-win,exchange-win-lay';
  }
  return betTypes;
}
